import { bootstrap } from './bootstrap.js';

document.addEventListener('DOMContentLoaded', bootstrap);